export enum MDBDiagnosticStatuses {
  POWERING_UP = 'POWERING_UP',
  POWERING_DOWN = 'POWERING_DOWN',
  OK = 'OK',
  KEYPAD_SHIFTED = 'KEYPAD_SHIFTED',
  MANUAL_FILL_OR_PAYOUT_ACTIVE = 'MANUAL_FILL_OR_PAYOUT_ACTIVE',
  NEW_INVENTORY_INFORMATION_AVAILABLE = 'NEW_INVENTORY_INFORMATION_AVAILABLE',
  INHIBITED_BY_VMC = 'INHIBITED_BY_VMC',
  GENERAL_CHANGER_ERROR = 'GENERAL_CHANGER_ERROR',
  GENERAL_CHANGER_ERROR_CHECKSUM_1 = 'GENERAL_CHANGER_ERROR_CHECKSUM_1',
  GENERAL_CHANGER_ERROR_CHECKSUM_2 = 'GENERAL_CHANGER_ERROR_CHECKSUM_2',
  GENERAL_CHANGER_ERROR_LOW_LINE_VOLTAGE = 'GENERAL_CHANGER_ERROR_LOW_LINE_VOLTAGE',
  DISCRIMINATOR_MODULE_ERROR = 'DISCRIMINATOR_MODULE_ERROR',
  DISCRIMINATOR_MODULE_ERROR_FLIGHT_DECK_OPEN = 'DISCRIMINATOR_MODULE_ERROR_FLIGHT_DECK_OPEN',
  DISCRIMINATOR_MODULE_ERROR_ESCROW_RETURN_STUCK_OPEN = 'DISCRIMINATOR_MODULE_ERROR_ESCROW_RETURN_STUCK_OPEN',
  DISCRIMINATOR_MODULE_ERROR_COIN_JAM_IN_SENSOR = 'DISCRIMINATOR_MODULE_ERROR_COIN_JAM_IN_SENSOR',
  DISCRIMINATOR_MODULE_ERROR_DISCRIMINATOR_BELOW_STANDARD = 'DISCRIMINATOR_MODULE_ERROR_DISCRIMINATOR_BELOW_STANDARD',
  DISCRIMINATOR_MODULE_ERROR_SENSOR_A_OUT_OF_RANGE = 'DISCRIMINATOR_MODULE_ERROR_SENSOR_A_OUT_OF_RANGE',
  DISCRIMINATOR_MODULE_ERROR_SENSOR_B_OUT_OF_RANGE = 'DISCRIMINATOR_MODULE_ERROR_SENSOR_B_OUT_OF_RANGE',
  DISCRIMINATOR_MODULE_ERROR_SENSOR_C_OUT_OF_RANGE = 'DISCRIMINATOR_MODULE_ERROR_SENSOR_C_OUT_OF_RANGE',
  DISCRIMINATOR_MODULE_ERROR_TEMPERATURE_EXCEEDED = 'DISCRIMINATOR_MODULE_ERROR_TEMPERATURE_EXCEEDED',
  DISCRIMINATOR_MODULE_ERROR_SIZING_OPTICS_FAILURE = 'DISCRIMINATOR_MODULE_ERROR_SIZING_OPTICS_FAILURE',
  ACCEPT_GATE_MODULE_ERROR = 'ACCEPT_GATE_MODULE_ERROR',
  ACCEPT_GATE_MODULE_ERROR_COIN_ENTERED_GATE_BUT_NOT_EXIT = 'ACCEPT_GATE_MODULE_ERROR_COIN_ENTERED_GATE_BUT_NOT_EXIT',
  ACCEPT_GATE_MODULE_ERROR_ALARM_ACTIVE = 'ACCEPT_GATE_MODULE_ERROR_ALARM_ACTIVE',
  ACCEPT_GATE_MODULE_ERROR_GATE_OPENED_BUT_NO_COIN_DETECTED = 'ACCEPT_GATE_MODULE_ERROR_GATE_OPENED_BUT_NO_COIN_DETECTED',
  ACCEPT_GATE_MODULE_ERROR_POST_GATE_SENSOR_COVERED_BEFORE_GATE_OPENED = 'ACCEPT_GATE_MODULE_ERROR_POST_GATE_SENSOR_COVERED_BEFORE_GATE_OPENED',
  SEPARATOR_MODULE_ERROR = 'SEPARATOR_MODULE_ERROR',
  SEPARATOR_MODULE_ERROR_SORT_SENSOR_ERROR = 'SEPARATOR_MODULE_ERROR_SORT_SENSOR_ERROR',
  DISPENSER_MODULE_ERROR = 'DISPENSER_MODULE_ERROR',
  COIN_CASSETTE_OR_TUBE_MODULE_ERROR = 'COIN_CASSETTE_OR_TUBE_MODULE_ERROR',
  COIN_CASSETTE_OR_TUBE_MODULE_ERROR_CASSETE_REMOVED = 'COIN_CASSETTE_OR_TUBE_MODULE_ERROR_CASSETE_REMOVED',
  COIN_CASSETTE_OR_TUBE_MODULE_ERROR_CASHBOX_SENSOR_ERROR = 'COIN_CASSETTE_OR_TUBE_MODULE_ERROR_CASHBOX_SENSOR_ERROR',
  COIN_CASSETTE_OR_TUBE_MODULE_ERROR_SUNLIGHT_ON_TUBE_SENSORS = 'COIN_CASSETTE_OR_TUBE_MODULE_ERROR_SUNLIGHT_ON_TUBE_SENSORS',
}
